module.exports = __webpack_public_path__ + "assets/media/morning.86d67dd9.mp3";